import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useQuery } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import '../../../context/actions.js';
import '../../../context/reducer.js';
import { useProductData } from '../../../context/product-context-hooks.js';
import '../../../context/ProductContext.js';
import '../../../context/CmsContext.js';
import '../../../operations/queries/get-accessories-by-slug.js';
import '../../../operations/queries/get-contact-lens-by-slug.js';
import '../../../operations/queries/get-frames-by-slug.js';
import '../../../operations/queries/get-solutions-by-slug.js';
import '../../../operations/queries/get-sunglasses-by-slug.js';
import '../../../operations/queries/get-ready-reader-by-slug.js';
import '../../../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import { GET_MANUFACTURER_BY_KEY } from '../../../operations/queries/get-manufacturer-by-key.js';
import { mapManufacturerToClient } from './map-to-manufacturer.js';
import { ProductDetailManufacturer } from './ProductDetailManufacturer.js';

const ProductDetailManufacturerDrawerContainer = ()=>{
    const { getLabel  } = useIntl();
    const { product  } = useProductData();
    const title = getLabel('products.detail.manufacturer.title');
    var _supplier;
    const { data , error  } = useQuery(GET_MANUFACTURER_BY_KEY, {
        skip: !product.supplier,
        variables: {
            key: (_supplier = product.supplier) !== null && _supplier !== void 0 ? _supplier : ''
        }
    });
    const manufacturer = React.useMemo(()=>{
        return mapManufacturerToClient(data === null || data === void 0 ? void 0 : data.manufacturer);
    }, [
        data
    ]);
    if (error || !manufacturer) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("section", {
        className: "product-detail-manufacturer",
        "aria-label": title,
        "data-t": "product-detail-manufacturer"
    }, /*#__PURE__*/ React.createElement(ProductDetailManufacturer, swcHelpers.extends({
        title: title
    }, manufacturer)));
};

export { ProductDetailManufacturerDrawerContainer };
//# sourceMappingURL=ProductDetailManufacturerDrawerContainer.js.map
